import { supabase } from '@/integrations/supabase/client';
import { getAllCoursesUnified } from '@/utils/allCourses';

export const setupAdminUser = async () => {
  try {
    // Get current user
    const { data: { user } } = await supabase.auth.getUser();
    if (!user || user.email !== 'iam_bal@hotmail.com') {
      return { success: false, error: 'Not authorized admin user' };
    }

    console.log('Setting up admin user:', user.email, 'ID:', user.id);

    // Get all available courses
    const allCourses = getAllCoursesUnified();
    console.log('Total courses to assign:', allCourses.length);
    
    // Check existing assignments
    const { data: existingAssignments } = await supabase
      .from('course_assignments')
      .select('course_id')
      .eq('user_id', user.id);

    const assignedCourseIds = new Set(existingAssignments?.map(a => a.course_id) || []);
    const coursesToAssign = allCourses.filter(course => !assignedCourseIds.has(course.id));
    
    console.log('Already assigned:', assignedCourseIds.size, 'Need to assign:', coursesToAssign.length);
    
    if (coursesToAssign.length === 0) {
      console.log('Admin already enrolled in all courses');
      return { success: true, message: 'Already enrolled in all courses', assignedCourses: assignedCourseIds.size };
    }

    // Batch insert new assignments
    const newAssignments = coursesToAssign.map(course => ({
      user_id: user.id,
      course_id: course.id,
      assigned_by: user.id,
      assignment_status: 'assigned',
      status: 'active',
      final_grade: 0
    }));

    let successCount = 0;
    if (newAssignments.length > 0) {
      const { data, error } = await supabase
        .from('course_assignments')
        .insert(newAssignments)
        .select('course_id');

      if (error) {
        console.error('Error batch inserting assignments:', error);
        // Try individual inserts as fallback
        for (const assignment of newAssignments) {
          try {
            const { error: individualError } = await supabase
              .from('course_assignments')
              .insert(assignment);
            
            if (!individualError) {
              successCount++;
              console.log(`Successfully assigned course: ${assignment.course_id}`);
            } else {
              console.error(`Error assigning course ${assignment.course_id}:`, individualError);
            }
          } catch (error) {
            console.error(`Error processing course ${assignment.course_id}:`, error);
          }
        }
      } else {
        successCount = data?.length || 0;
        console.log(`Successfully batch assigned ${successCount} courses`);
      }
    }

    // Verify assignments
    const { data: assignments, error: fetchError } = await supabase
      .from('course_assignments')
      .select('course_id')
      .eq('user_id', user.id);

    if (fetchError) {
      console.error('Error fetching assignments:', fetchError);
    } else {
      console.log('Total assignments created:', assignments?.length || 0);
      console.log('Assigned courses:', assignments?.map(a => a.course_id) || []);
    }

    console.log('Admin setup completed successfully');

    return {
      success: true,
      assignedCourses: assignments?.length || 0,
      newlyAssigned: successCount
    };
  } catch (error) {
    console.error('Error setting up admin user:', error);
    return {
      success: false,
      error: error.message
    };
  }
};